var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCargoShipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328.57,
    height: 78.773,
    viewBox: "0 0 328.57 78.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cargo_Ship",
    "data-name": "Cargo Ship",
    transform: "translate(-1675.25 -1720.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Containers_All",
    "data-name": "Containers All",
    transform: "translate(1707.717 1748.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Containers",
    transform: "translate(265.699 8.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container",
    width: 7.263,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-2",
    "data-name": "container",
    width: 7.263,
    height: 4.842,
    transform: "translate(0 9.857)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-3",
    "data-name": "container",
    width: 7.263,
    height: 4.842,
    transform: "translate(0 5.015)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-4",
    "data-name": "container",
    width: 7.263,
    height: 5.015,
    fill: "#006762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-2",
    "data-name": "Containers",
    transform: "translate(257.225 8.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-5",
    "data-name": "container",
    width: 7.263,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-6",
    "data-name": "container",
    width: 7.263,
    height: 4.842,
    transform: "translate(0 9.857)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-7",
    "data-name": "container",
    width: 7.263,
    height: 4.842,
    transform: "translate(0 5.015)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-8",
    "data-name": "container",
    width: 7.263,
    height: 5.015,
    fill: "#006762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-3",
    "data-name": "Containers",
    transform: "translate(236.474 4.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-9",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-10",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-11",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 9.857)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-12",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-13",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-4",
    "data-name": "Containers",
    transform: "translate(215.722 4.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-14",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-15",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-16",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 9.857)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-17",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-18",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-5",
    "data-name": "Containers",
    transform: "translate(195.032 4.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-19",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-20",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-21",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 9.857)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-22",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-23",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-6",
    "data-name": "Containers",
    transform: "translate(174.303 4.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-24",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-25",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-26",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 9.857)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-27",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-28",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-7",
    "data-name": "Containers",
    transform: "translate(153.573 4.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-29",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-30",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-31",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 9.857)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-32",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-33",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-8",
    "data-name": "Containers",
    transform: "translate(153.573 4.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-34",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-35",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-36",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 9.857)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-37",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-38",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-9",
    "data-name": "Containers",
    transform: "translate(132.843 4.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-39",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-40",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-41",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 9.857)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-42",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-43",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-10",
    "data-name": "Containers",
    transform: "translate(112.113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-44",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-45",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-46",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 9.684)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-47",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-48",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-49",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 24.383)",
    fill: "#008e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-11",
    "data-name": "Containers",
    transform: "translate(91.384)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-50",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-51",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-52",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 9.684)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-53",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-54",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-55",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 24.383)",
    fill: "#008e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-12",
    "data-name": "Containers",
    transform: "translate(70.654)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-56",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-57",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-58",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 9.684)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-59",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-60",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-61",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 24.383)",
    fill: "#008e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-13",
    "data-name": "Containers",
    transform: "translate(49.924)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-62",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-63",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-64",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 9.684)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-65",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-66",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-67",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 24.383)",
    fill: "#008e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-14",
    "data-name": "Containers",
    transform: "translate(29.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-68",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-69",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-70",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 9.684)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-71",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-72",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-73",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 24.383)",
    fill: "#008e7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-15",
    "data-name": "Containers",
    transform: "translate(8.474 4.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-74",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 19.541)",
    fill: "#006762"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-75",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-76",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    transform: "translate(0 9.857)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-77",
    "data-name": "container",
    width: 19.541,
    height: 5.015,
    transform: "translate(0 4.842)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-78",
    "data-name": "container",
    width: 19.541,
    height: 4.842,
    fill: "#006762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Containers-16",
    "data-name": "Containers",
    transform: "translate(0 8.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-79",
    "data-name": "container",
    width: 7.263,
    height: 4.842,
    transform: "translate(0 14.699)",
    fill: "#76c8ae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-80",
    "data-name": "container",
    width: 7.263,
    height: 4.842,
    transform: "translate(0 9.857)",
    fill: "#00ae9d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-81",
    "data-name": "container",
    width: 7.263,
    height: 4.842,
    transform: "translate(0 5.015)",
    fill: "#008e7a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "container-82",
    "data-name": "container",
    width: 7.263,
    height: 5.015,
    fill: "#006762"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ship",
    transform: "translate(1675.25 1720.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Propeller",
    transform: "translate(14.31 68.493)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "propeller-2",
    "data-name": "propeller",
    width: 4.842,
    height: 2.421,
    transform: "translate(1.211 2.421)",
    fill: "#8197a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "blades",
    width: 1.211,
    height: 7.263,
    fill: "#8197a6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ship-base-bottom",
    d: "M21228.35,4035.081c.139-1.782-4.246-7.811-2.053-8.787s48.1,0,48.1,0l5.826,3.906h218.641l18.084-5.2h35.842s-5.543,9.1-7.1,10.081,1.6,9.934,3.627,10.74-.35,4.882-3.627,5.052-281.836,0-281.836,0l-18.529-1.147s-1.934-9.422-3.326-9.593-6.437,0-6.437,0S21228.213,4036.863,21228.35,4035.081Z",
    transform: "translate(-21225.16 -3972.404)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aft_fin",
    "data-name": "aft fin",
    d: "M21236.746,4038.216v7.664h-6.027v-10.74Z",
    transform: "translate(-21224.043 -3970.17)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Windows_bottom",
    "data-name": "Windows bottom",
    transform: "translate(5.836 48.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(29.225)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.263,
    height: 4.842,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6.263,
    height: 3.842,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    transform: "translate(21.962)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.263,
    height: 4.842,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6.263,
    height: 3.842,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    transform: "translate(14.526)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.436,
    height: 4.842,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6.436,
    height: 3.842,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    transform: "translate(7.263)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.263,
    height: 4.842,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6.263,
    height: 3.842,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.263,
    height: 4.842,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6.263,
    height: 3.842,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "aft_room",
    "data-name": "aft room",
    width: 13.489,
    height: 4.842,
    transform: "translate(9.468 44.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Windows_Tower",
    "data-name": "Windows Tower",
    transform: "translate(22.957 22.184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "tower",
    width: 19.368,
    height: 26.804,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "window",
    transform: "translate(2.421 2.421)",
    stroke: "#545759",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.211,
    height: 2.421,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.211,
    height: 1.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window-2",
    "data-name": "window",
    transform: "translate(9.684 2.421)",
    stroke: "#545759",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.211,
    height: 2.421,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.211,
    height: 1.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window-3",
    "data-name": "window",
    transform: "translate(15.737 4.842)",
    stroke: "#545759",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.211,
    height: 2.421,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.211,
    height: 1.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window-4",
    "data-name": "window",
    transform: "translate(13.316 9.684)",
    stroke: "#545759",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.211,
    height: 2.421,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.211,
    height: 1.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window-5",
    "data-name": "window",
    transform: "translate(7.263 8.474)",
    stroke: "#545759",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.211,
    height: 2.421,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.211,
    height: 1.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window-6",
    "data-name": "window",
    transform: "translate(1.211 7.263)",
    stroke: "#545759",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.211,
    height: 2.421,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.211,
    height: 1.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window-7",
    "data-name": "window",
    transform: "translate(3.632 13.316)",
    stroke: "#545759",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.211,
    height: 2.421,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.211,
    height: 1.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window-8",
    "data-name": "window",
    transform: "translate(8.474 15.737)",
    stroke: "#545759",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.211,
    height: 2.594,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.211,
    height: 1.594,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window-9",
    "data-name": "window",
    transform: "translate(13.316 15.737)",
    stroke: "#545759",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.211,
    height: 2.594,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.211,
    height: 1.594,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window-10",
    "data-name": "window",
    transform: "translate(15.737 21.962)",
    stroke: "#545759",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.211,
    height: 2.421,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.211,
    height: 1.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window-11",
    "data-name": "window",
    transform: "translate(8.474 21.962)",
    stroke: "#545759",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.211,
    height: 2.421,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.211,
    height: 1.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "window-12",
    "data-name": "window",
    transform: "translate(1.211 21.962)",
    stroke: "#545759",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.211,
    height: 2.421,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 0.211,
    height: 1.421,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "tower_top_base",
    "data-name": "tower top base",
    d: "M21266.861,4001.33h-26.385v-4.935h26.385Z",
    transform: "translate(-21221.889 -3978.661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Radio_Tower",
    "data-name": "Radio Tower",
    transform: "translate(35.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M21256.648,3998.419v-11.236h1.883v-4.371",
    transform: "translate(-21254.055 -3980.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M21255.91,3998.851s-.059-11.753,0-11.649l-1.947.017-.447-.017v-6.352",
    transform: "translate(-21253.516 -3980.85)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "tower_top_roof",
    "data-name": "tower top roof",
    d: "M21252.352,3998.3v-11.405h-5.184l-2.238,11.845h8.131Z",
    transform: "translate(-21220.902 -3980.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Antenna_front",
    "data-name": "Antenna front",
    transform: "translate(304.968 31.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M21484.563,4028.231v-5.8h1.758v-5.187h2.059v-9.458",
    transform: "translate(-21484.563 -4007.789)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M21490.422,4026.867v-8.9H21492v-3.993",
    transform: "translate(-21483.277 -4006.425)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "baseline",
    d: "M316.542.063,1.074-.288",
    transform: "translate(2.983 64.126)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "ship_base_bottom",
    "data-name": "ship base  bottom",
    d: "M21544.355,4042.979c.047-4.472-305.627-.219-305.627-.219l.422,3.032.7.49,20,1.113h278.516S21544.309,4047.452,21544.355,4042.979Z",
    transform: "translate(-21219.377 -3968.622)",
    fill: "#003247"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ship_base_top",
    "data-name": "ship base top",
    d: "M21545.074,4036.714c-3.027.529-316.4-.458-316.4-.458l-2.627-5.645-.807-4.333,4.818-.808,44.467.808,6.236,3.372,218.811-.213,15.432-4.989h38.807S21548.1,4036.186,21545.074,4036.714Z",
    transform: "translate(-21225.242 -3972.511)",
    fill: "#8197a6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoShipIcon);
export default __webpack_public_path__ + "static/media/cargo-ship-icon.977334f0b7d55c5d89059410f6ed0c6f.svg";
export { ForwardRef as ReactComponent };